import { ITextValueOption } from '@waseel-asp/tpa-waseel-lib-staging';

export interface ICommonlov {
  lovId: string;
  code?: string;
  nameEnglish: string;
  nameArabic: string;
  descriptionEnglish?: string;
  descriptionArabic?: string;
  entityType: string;
  entityTypeId: string;
  entityTypeDescription: string;
}

export const commonLovConfig = {
  code: 'FORM_FIELD.CODE',
  entityName: 'CONFIGURATION.COMMONLOV.TITLE',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
  descriptionArabic: 'FORM_FIELD.ARABIC_DESCRIPTION',
  descriptionEnglish: 'FORM_FIELD.ENGLISH_DESCRIPTION',
  entityType: 'FORM_FIELD.ENTITY_TYPE',
};

export interface commonLovDropDownConfig {
  formControlName: string,
  label: string,
  entityType?: string,
  loadFromApi?: boolean,
  allowSearching?: boolean,
  allowMultiple?: boolean,
  showAllOptions?: boolean,
  showToggleAllCheckbox?: boolean,
  allowClear?: boolean,
  isDisable?: boolean,
  data?: ITextValueOption[],
  selectedOptions?: ITextValueOption[],
  selectionChange?(data: ITextValueOption | ITextValueOption[]): void;
}
